export default "__VITE_ASSET__DU3tUnb6__"